import { useEffect } from 'react'
import { useCheckoutResult } from '../../hooks'
import styles from './CheckoutBanner.module.css'

const MESSAGES = {
  success: {
    title: '¡Gracias por tu compra!',
    body: 'Tu pago se procesó correctamente. Recibirás la confirmación por correo.',
  },
  cancel: {
    title: 'Pago cancelado',
    body: 'No se realizó ningún cargo. Tu carrito sigue intacto cuando quieras continuar.',
  },
} as const

/**
 * Aviso flotante que se muestra al volver de Stripe Checkout. Se cierra solo
 * tras unos segundos en caso de éxito, o manualmente con el botón.
 */
export function CheckoutBanner() {
  const { status, dismiss } = useCheckoutResult()

  useEffect(() => {
    if (status !== 'success') return
    const timer = setTimeout(dismiss, 8000)
    return () => clearTimeout(timer)
  }, [status, dismiss])

  if (!status) return null

  const message = MESSAGES[status]

  return (
    <div
      className={`${styles.banner} ${styles[status]}`}
      role="status"
      aria-live="polite"
    >
      <div className={styles.text}>
        <strong className={styles.title}>{message.title}</strong>
        <span>{message.body}</span>
      </div>
      <button
        type="button"
        className={styles.close}
        onClick={dismiss}
        aria-label="Cerrar aviso"
      >
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <path d="M18 6L6 18M6 6l12 12" />
        </svg>
      </button>
    </div>
  )
}
